module.exports = __webpack_public_path__ + "static/img/bg2.7c752c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg2.jpg
// module id = sePA
// module chunks = 1